import { render, staticRenderFns } from "./SavedToPendingTRModal.vue?vue&type=template&id=6560b468"
import script from "./savedToPendingTRModal.ts?vue&type=script&lang=ts&external"
export * from "./savedToPendingTRModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6560b468')) {
      api.createRecord('6560b468', component.options)
    } else {
      api.reload('6560b468', component.options)
    }
    module.hot.accept("./SavedToPendingTRModal.vue?vue&type=template&id=6560b468", function () {
      api.rerender('6560b468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/team-request-detail/buttons-group/modal/client/savedToPendingTR/SavedToPendingTRModal.vue"
export default component.exports